import { css } from '@emotion/react';

export const checkboxRowStyle = css({
  display: 'flex',
  alignItems: 'center',
  fontSize: '14px',
  marginTop: 8,
  gap: 8,
});
